import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=b833a008&scoped=true&"
import script from "./ClientDetail.vue?vue&type=script&lang=js&"
export * from "./ClientDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetail.vue?vue&type=style&index=0&id=b833a008&prod&scoped=true&lang=css&"
import style1 from "./ClientDetail.vue?vue&type=style&index=1&id=b833a008&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b833a008",
  null
  
)

export default component.exports